<template>
  <v-footer class="sub-footer-container">
    <v-col class="sub-footer-inner">
      <v-row class="footer-main py-8" align="start">

        <!-- Colonne gauche : logo + description + contact + stores -->
        <v-col lg="5" md="5" sm="12" class="left-col">
          <v-img :src="require('@/assets/images/footerlogo.png')" width="160" class="mb-4"></v-img>

          <p class="footer-desc">
            Experts en veille, accompagnement et dématérialisation des marchés publics.
            Optimisez vos chances de remporter des appels d'offres.
          </p>

          <div class="contact-list mt-4">
            <a href="https://maps.google.com/?q=35+B+rue+Léon+Dauer,+94350+Villiers-sur-Marne" target="_blank" class="contact-item">
              <img :src="require('@/assets/icons/map.svg')" class="contact-icon">
              <span>35 B rue Léon Dauer, 94350 Villiers-sur-Marne</span>
            </a>
            <a href="mailto:contact@portailmarches.fr" class="contact-item">
              <img :src="require('@/assets/icons/mail.svg')" class="contact-icon">
              <span>contact@portailmarches.fr</span>
            </a>
            <div class="contact-item">
              <img :src="require('@/assets/icons/phone.svg')" class="contact-icon">
              <span>
                <a href="tel:+33189317696" class="contact-link">01 89 31 76 96</a>
                &nbsp;/&nbsp;
                <a href="tel:+33777301374" class="contact-link">07 77 30 13 74</a>
              </span>
            </div>
          </div>

          <div class="store-row mt-5">
            <a href="" class="store-link mr-3">
              <img :src="require('@/assets/icons/googleStore.svg')" class="store-icon">
            </a>
            <a href="" class="store-link">
              <img :src="require('@/assets/icons/appStore.svg')" class="store-icon">
            </a>
          </div>
        </v-col>

        <!-- Séparateur vertical -->
        <v-col lg="1" md="1" class="d-none d-md-flex justify-center">
          <v-divider vertical class="border-opacity-10" thickness="1"></v-divider>
        </v-col>

        <!-- Colonne droite : navigation -->
        <v-col lg="6" md="6" sm="12" class="right-col">
          <p class="nav-title">NAVIGATION</p>
          <v-row>
            <v-col cols="6">
              <router-link to="/" class="nav-link">Accueil</router-link>
              <router-link to="/search" class="nav-link">Recherche avancée</router-link>
              <router-link to="/espaceFournisseurs" class="nav-link">Espace Fournisseurs</router-link>
            </v-col>
            <v-col cols="6">
              <router-link to="/espaceAcheteurs" class="nav-link">Espace Acheteurs</router-link>
              <router-link to="/demat" class="nav-link">Dématérialisation</router-link>
              <router-link to="/faq" class="nav-link">FAQ</router-link>
              <router-link to="/contact" class="nav-link">Contact</router-link>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'SubFooterView',
  data() {
    return {}
  },
}
</script>

<style scoped>
.sub-footer-container {
  color: #DCE3ED !important;
  background-color: #304353 !important;
}

.sub-footer-inner {
  padding-left: 14.71rem !important;
  padding-right: 14.71rem !important;
  margin: auto;
}

.footer-desc {
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.82rem;
  line-height: 1.6rem;
  color: #a8b8c8;
  margin: 0;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.82rem;
  color: #DCE3ED;
  text-decoration: none;
  transition: color 0.2s;
}

.contact-item:hover {
  color: #DCC6A5;
}

.contact-icon {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.contact-link {
  color: #DCE3ED;
  text-decoration: none;
  transition: color 0.2s;
}

.contact-link:hover {
  color: #DCC6A5;
}

.store-row {
  display: flex;
  align-items: center;
}

.store-link {
  display: inline-block;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.store-link:hover {
  opacity: 1;
}

.store-icon {
  width: 5.5rem;
  height: 1.9rem;
  border-radius: 0.3rem;
  display: block;
}

.nav-title {
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.1rem;
  color: #DCC6A5;
  margin-bottom: 1.2rem;
}

.nav-link {
  display: block;
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.85rem;
  color: #DCE3ED;
  text-decoration: none;
  padding: 0.35rem 0;
  transition: color 0.2s;
}

.nav-link:hover {
  color: #DCC6A5;
}

.left-col {
  padding-right: 2rem;
}

.right-col {
  padding-left: 2rem;
}

@media (max-width: 960px) {
  .sub-footer-inner {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  .left-col, .right-col {
    padding: 1rem 0;
  }
}

@media (max-width: 600px) {
  .sub-footer-inner {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .footer-main {
    flex-direction: column;
  }
}
</style>
